import React from 'react';
import { useState, useEffect } from 'react';
import {
  Card, CardHeader, Table,
  Container, Row, Button, Modal, Col, Spinner,
  FormGroup, Label, Input, ModalBody, ModalFooter
} from "reactstrap";
import { Form, Field } from "react-final-form";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import dataProvider from "dataProvider";
import { useHistory } from "react-router-dom";
import auth from "authProvider";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import decodeJwt from 'jwt-decode';
import Pdf from "react-to-pdf";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { AiOutlineArrowRight } from "react-icons/ai";
import Scrollbars from 'react-custom-scrollbars';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
const token = localStorage.getItem('token');
const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
// export const ExportToExcel = ({ fileName, filterProps }) => {
//   const exportToCSV = (apiData, fileName) => {
//     let api_data = apiData.map(product => ({ 'Product': product?.name, 'Category': product?.category?.category, 'Supplier': product?.supplier?.supplier, 'SKU': product?.sku, 'Quantity': product?.quantity, 'Price': product?.price, 'Unit': product?.unit }))
//     const ws = XLSX.utils.json_to_sheet(api_data);
//     const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const data = new Blob([excelBuffer], { type: fileType });
//     FileSaver.saveAs(data, fileName + fileExtension);
//   };
//   const getEntireData = (fileName, filteritems) => {
//     dataProvider.getList('products', { params: { filter: filteritems, pagination: { page: 1, perPage: 200000000000000 }, sort: { order: 'desc', field: 'id' }, token: token } })
//       .then(({ data }) => {
//         if (data?.length > 0)
//           exportToCSV(data, fileName);
//       })
//   };
//   return (
//     <Button onClick={(e) => getEntireData(fileName, filterProps)} style={{ padding: 5, boxShadow: 0, borderWidth: 1, borderColor: '#ccc' }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="share" /></Button>
//   );
// };

const Partsinventory = (props) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [view_open, setview_Open] = useState(false);
  const [pos, setPos] = useState(false);
  const [page, setPage] = useState(1);
  const [more, setMore] = useState(true);
  const [flag, setFlag] = useState(false);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState(false);
  const [category, setCategory] = useState(false);
  const [brands, setBrands] = useState(false);
  const [suppliers, setSuppliers] = useState(false);
  const [selectedOption_category, setSelectedOption_category] = useState();
  const [selectedOption_brand, setSelectedOption_brand] = useState();
  const [selectedOption_supplier, setSelectedOption_supplier] = useState();
  const [selectedOption_unit, setSelectedOption_unit] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [purchaseOpen, setPurchaseOpen] = useState(false);
  const [filter, setFilter] = useState(false);
  const [searchterm, setSearchTerm] = useState('');
  const [searchbrand, setSearchBrand] = useState(false);
  const [searchcategory, setSearchCategory] = useState(false);
  const [searchsupplier, setSearchSupplier] = useState(false);
  const [searchstock, setSearchStock] = useState();
  const [confirmOpen, setConfirmOpen] = useState({ visible: false, id: null, index: null });
  const [sucess, setSucess] = useState(false);
  const [selectedproducts, setSelectedproducts] = useState([])
  const [productresult, setProductresult] = useState(false)
  const [quantity, setQuantity] = useState(false)
  const [searchinfo, setSearchinfo] = useState([])
  const [peropen, setPeropen] = useState(false);
  const [alreadyexist, setAlreadyexist] = useState(false);
  const [exported, setExported] = useState([]);
  const [count, setCount] = useState(null);
  const [productid, setProductid] = useState(null)
  const [purchasedata, Setpurchasedata] = useState(false)
  const [purchaseid, Setpurchaseid] = useState(false)
  const [error, setError] = useState('');
  const [filterProps, setFilterProps] = useState({});
  const [locations, setLocations] = useState(false);

  const ref = React.createRef();
  const onLogout = () => {
    auth.logout();
    history.push("/")
  }
  useEffect(() => {
    let filter = {};
    dataProvider.getList('products', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        // if (data && data.length > 0) {
        //   var result = data.map(product => ({ id: product.id, name: product.name, sku: product.sku }));
        //   setProductresult(result);
        //   setSearchTerm('')
        // }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setProducts(data)
        if (data && data.length > 0) {
          var obj = data.map(product => ({ ProductName: product?.name, category: product?.category?.category, Supplier: product?.supplier?.supplier ? product?.supplier?.supplier : null, SKU: product?.sku, Quantity: product?.quantity, Price: product?.price, Unit: product?.unit }));
          setExported(obj);
        }
      })
    dataProvider.getList('locations/list', { params: { pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => {
        setLocations(data[0].data);
      })
      .catch(error => {
        setLoading(false)
      });
    // dataProvider.getList('products', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
    //   .then(({ data }) => {
    //     console.log(data);
    //     if (data && data.length > 0) {
    //       var result = data.map(product => ({ id: product.id, name: product.name, sku: product.sku }));
    //       setProductresult(result);
    //       setSearchTerm('')
    //     }
    //   })
    dataProvider.getList('product_categories/list', { params: { pagination: { page: 1, perPage: 50 }, sort: { order: 'desc', field: 'id' }, filter: {}, token: token } })
      .then(({ data }) => { setCategory(data[0].data); })
    dataProvider.getList('brands', { params: { pagination: { page: 1, perPage: 50 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setBrands(data); })
    dataProvider.getList('suppliers', { params: { pagination: { page: 1, perPage: 50 }, sort: { order: 'desc', field: 'id' } }, filter: {} })
      .then(({ data }) => { setSuppliers(data); })
  }, [props, reload]);
  // console.log(locations);

  const onFilterQuery = (c_page) => {
    let filter = {};
    if (searchterm) {
      filter.name_lower = searchterm.toLowerCase().replace(/\s/g, '');
    }
    if (searchbrand) {
      filter.brand = searchbrand;
    }
    if (searchcategory) {
      filter.category = searchcategory;
    }
    if (searchsupplier) {
      filter.supplier = searchsupplier;
    }

    setFilterProps({ filter: filter, stock: searchstock });
    dataProvider.getList('products', { params: { filter: filter, stock: searchstock, pagination: { page: c_page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var result = data.map(product => ({ name: product.name, id: product.id }));
          setProductresult(result);
          setSearchTerm('')
        }
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setProducts(data)

        if (data && data.length > 0) {
          var obj = data.map(product => ({ id: product?.id, ProductName: product?.name, category: product?.category?.category, Supplier: product?.supplier?.supplier ? product?.supplier?.supplier : null, SKU: product?.sku, Quantity: product?.quantity, Price: product?.price, Unit: product?.unit }));
          setExported(obj);
        }
      }).catch(error => {
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  }
  const exportToCSV = (apiData, fileName) => {
    let api_data = apiData.map(product => ({ 'Product': product?.name, 'Category': product?.category?.category, 'Supplier': product?.supplier?.supplier, 'SKU': product?.sku, 'Quantity': product?.quantity, 'Price': product?.price, 'Unit': product?.unit }))
    const ws = XLSX.utils.json_to_sheet(api_data);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  const getEntireData = (fileName) => {
    dataProvider.getList('products', { params: { filter: filterProps.filter, stock: filterProps.stock, pagination: { page: 1, perPage: 200000000000000 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data?.length > 0)
          exportToCSV(data, fileName);
      })
  };
  const onSubmit = values => {
    setLoading(true)
    dataProvider.create('products', { params: { ...values, category: selectedOption_category, brand: selectedOption_brand, supplier: selectedOption_supplier, unit: selectedOption_unit } })
      .then(({ data }) => {
        let timer = setTimeout(() => setSucess(false), 2000);
        setLoading(false)
        setSucess(true)
        history.push("/partsinventory");
        setOpen(false);
      })
      .catch(error => {
        setLoading(false)
        alert(error.message)
      });
  }
  const onSubmit_purchase = () => {
    purchaseClose(true)
    window.location.reload();

  }
  const handleClickOpen = (index) => {
    setPos(index)
    setOpen(true);
  };
  const viewClose = () => {
    setview_Open(false);
  };
  const Closeconfirm = () => {
    setConfirmOpen({ visible: false, id: null, index: null });
  };
  const PurchaseOpen = () => {
    setPurchaseOpen(true);
    let filter = {};
    if (searchterm) {
      filter.name_lower = searchterm.toLowerCase().replace(/\s/g, '');
    }
    dataProvider.getList('products', { params: { filter: filter, pagination: { page: page, perPage: 800 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data && data.length > 0) {
          var result = data.map(product => ({ id: product.id, name: product.name, sku: product.sku }));
          setProductresult(result);
          setSearchTerm('')
        }
      })
  };
  const purchaseClose = () => {
    setSelectedproducts([]);
    setSearchinfo([]);
    setPurchaseOpen(false);
    window.location.reload();
  };
  const onPagination = (i) => {
    let newPage = page + i;
    if (newPage == 0) {
      return;
    }
    else if (i === 1 && !more) {
      return;
    }
    setPage(newPage);
    // setReload(!reload);
    onFilterQuery(newPage);
  }
  const removeData = (id, index) => {
    dataProvider.delete('products', { id: id });
    let productArr = products;
    productArr.splice(index, 1);
    setProducts(productArr);
    setFlag(!flag)
    setConfirmOpen({ visible: false, id: null, index: null });
  }
  const searchFilter = () => {
    setPage(1);
    onFilterQuery(1);
  }
  const Openfilter = () => {
    history.push('./partsinventory')
    setFilter(false)
  }
  const Closefilter = () => {
    setFilter(true)
  }
  const onSubmitFilter = values => {
  }
  const Filter_dropdown = () => {
    setPage(1);
    onFilterQuery(1);
  }
  const SearchInfoQuantity = (val, id) => {
    // const result = val.replace(/\D/g, '');
    // setValidatenumbr(result);
    setCount(val)
    setProductid(id)
    let newArr = [...searchinfo];
    let index = newArr.findIndex(i => i.productId === id);
    newArr[index].quantity = val;
    setSearchinfo(newArr);
    setError('')
  }

  const required = value => (value ? undefined : 'Required')
  const mustBeNumber = value => (isNaN(value) ? 'Must be a number' : undefined)
  const composeValidators = (...validators) => value =>
    validators.reduce((error, validator) => error || validator(value), undefined)

  const selectproducts = (val) => {
    let newList = selectedproducts.filter(item => item.id !== val.id)
    newList.push(val)
    setSelectedproducts(newList);//id and name

    var inPos = searchinfo.find(part => part.productId === val.id);
    if (inPos) {
      setAlreadyexist(true)
      // alert('product already exist');
      return;
    }
    setSearchinfo(prevState => [...prevState, { productId: val.id, productname: val.name, quantity: quantity }]);
    return;
  }
  const removeProducts = (id) => {
    let arrAfterRemove = selectedproducts.filter(item => item.id !== id)
    setSelectedproducts(arrAfterRemove);
    let arrAfterselect = searchinfo.filter(item => item.productId !== id)
    setSearchinfo(arrAfterselect);
  }

  const viewopen = (index) => {
    setPos(index)
    setview_Open(true);
  }
  const perModal = () => {
    setPeropen(true)
  }
  let token = localStorage.getItem('token');
  let per = localStorage.getItem('permission');
  const decodedToken = decodeJwt(token);
  // const per = decodedToken.user.permissions;
  const name = decodedToken.user.fullname;
  const userid = decodedToken.user.id;

  const options = {
    orientation: 'protrait',
    unit: 'mm',
    format: 'a4',
    // putOnlyUsedFonts:true,
    // floatPrecision: 16 
  };
  const onSubmitFilterkey = values => {
  }
  var today = new Date();
  const purchasedate = today.toLocaleDateString("en-US");

  const handleKeyPress = (event) => {
    setPage(1);
    // onFilterQuery();
    let filter = {};
    if (searchterm) {
      filter.name_lower = searchterm.toLowerCase().replace(/\s/g, '');
    }
    dataProvider.getList('products', { params: { filter: filter, pagination: { page: page, perPage: 20 }, sort: { order: 'desc', field: 'id' }, token: token } })
      .then(({ data }) => {
        if (data.length < 20) {
          setMore(false)
        }
        else {
          setMore(true)
        }
        setProducts(data)

        // if (data && data.length > 0) {
        //   var obj = data.map(product => ({ id: product?.id, ProductName: product?.name, category: product?.category?.category, Supplier: product?.supplier?.supplier ? product?.supplier?.supplier : null, SKU: product?.sku, Quantity: product?.quantity, Price: product?.price, Unit: product?.unit }));
        //   setExported(obj);
        // }
      }).catch(error => {
        if (error?.response?.data?.message === 'Invalid Token') {
          setModalOpen(true)
        }
      });
  }
  if (!products) {
    return (
      <>
        <div >
          <td style={{ color: '#12ACF6', position: "fixed", top: "50%", left: "55%", transform: "translate(-50%, -50%)" }} colSpan={11}><Spinner /></td>
        </div>
      </>
    )
  }

  const Purchasesave = () => {
    let falseArr = searchinfo.filter((item) => item.quantity == false);

    if (!falseArr.length) {
      setError('')
      dataProvider.create('purchase_order', { params: { productId: productid, count: count, creatorId: userid } })
        .then(({ data }) => {
          Setpurchasedata(data)
          Setpurchaseid(data.orderId)
          setError('')
        })
        .catch(error => {
          alert(error.message)
        })
    } else {
      setError('Please fill the quantity field')

    }

  }
  const Doc = () => (
    <Document>
      <Page size="A4" style={{
        paddingBottom: 30,
        paddingTop: 10
      }}>
        <View fixed style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', marginLeft: 45, paddingLeft: 45 }}>
          <Image style={{ height: 60, width: 60, marginRight: 60, marginBottom: 25, marginTop: 17 }} src={process.env.PUBLIC_URL + '/babal-logo.png'} />
          <Text style={{ fontSize: 12 }}>{purchaseid}</Text>
        </View>
        <View fixed style={{ display: 'flex', borderTop: '1.8px solid black', margin: '0px 20px 15px 20px' }}>
        </View>
        {/* borderLeft: '1.8px solid black', borderRight: '1px solid black',  */}
        <View style={{ alignItems: 'center', paddingLeft: 40, paddingRight: 40, paddingTop: 10, paddingBottom: 10, marginLeft: 20, marginRight: 20 }}>
          <View>
            <View style={{ display: 'flex', flexDirection: 'column', marginTop: 0 }}>
              <View style={{ display: 'flex', justifyContent: 'center', padding: '0px 160px 0px 160px' }}>
                <Text style={{ textAlign: 'center', color: 'black', fontSize: 16, width: 170, textDecoration: 'underline' }}>{'REQUEST FORM'}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', marginTop: 30 }}>
                <View style={{ display: 'flex', flex: 2, flexDirection: 'row', paddingRight: 30, marginTop: 25 }}>
                  <Text style={{ fontSize: 12, color: 'black' }}>{'Name:'}</Text>
                  <Text style={{ border: 'none', flex: 3, borderBottom: '1px solid black', width: '40%', marginBottom: 12, marginRight: 50, marginLeft: 5, fontSize: 12 }}>{name}</Text>
                </View>
                {/* <View style={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'center' }}>
                  <View style={{ alignItems: 'flex-start' }}>
                    <View style={{ display: 'flex', flexDirection: 'row' }}>
                      <View style={{ height: 15, width: 15, border: '2px solid red', marginLeft: 20 }}></View>
                      <Text style={{ fontSize: 12, marginLeft: 3, color: 'black' }}>From Supplier</Text>
                    </View>
                    <View style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
                      <View style={{ height: 15, width: 15, border: '2px solid red', marginLeft: 20 }}></View>
                      <Text style={{ fontSize: 12, marginLeft: 3, color: 'black' }}>From Store</Text>
                    </View>
                  </View>
                </View> */}
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
                <Text style={{ fontSize: 12, color: 'black' }}>Location:</Text>
                <View style={{ border: 'none', borderBottom: '1px solid black', width: '40%', marginBottom: 12, marginRight: 50, marginLeft: 5 }}></View>
                <Text style={{ fontSize: 12, color: 'black' }}>Date:</Text>
                <Text style={{ border: 'none', borderBottom: '1px solid black', marginBottom: 12, marginLeft: 5, fontSize: 12, width: 80 }}>{purchasedate}</Text>
              </View>
              {/* <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 15 }}>
                <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ fontSize: 12, color: 'black' }}>{'Electrical'}</Text>
                  <View style={{ height: 18, width: 18, border: '1px solid black', marginLeft: 20, marginTop: 2 }}></View>
                </View>
                <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ fontSize: 12, color: 'black' }}>{'Carpentory'}</Text>
                  <View style={{ height: 18, width: 18, border: '1px solid black', marginLeft: 20, marginTop: 2 }}></View>
                </View>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 15 }}>
                <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ fontSize: 12, color: 'black' }}>{'A/C'}</Text>
                  <View style={{ height: 18, width: 18, border: '1px solid black', marginLeft: 48, marginTop: 2 }}></View>
                </View>
                <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ fontSize: 12, color: 'black' }}>{'Structural'}</Text>
                  <View style={{ height: 18, width: 18, border: '1px solid black', marginLeft: 20, marginTop: 2 }}></View>
                </View>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 15 }}>
                <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ fontSize: 12, color: 'black' }}>{'Plumbing'}</Text>
                  <View style={{ height: 18, width: 18, border: '1px solid black', marginLeft: 20, marginTop: 2 }}></View>
                </View>
                <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ fontSize: 12, color: 'black' }}>{'Others'}</Text>
                  <View style={{ height: 18, width: 18, border: '1px solid black', marginLeft: 20, marginTop: 2 }}></View>
                </View>
              </View> */}
              <View style={{
                flexDirection: 'row',
                borderBottomColor: '#bff0fd',
                backgroundColor: '#808080',
                marginTop: 20,
                fontSize: 10,
                alignItems: 'center',
                height: 20,
              }}>
                <Text style={{
                  width: '10%',
                  borderRightColor: '#fff',
                  borderRightWidth: 1,
                  textAlign: 'center',
                }}>S#</Text>
                <Text style={{
                  width: '60%',
                  borderRightColor: '#fff',
                  borderRightWidth: 1,
                  textAlign: 'center'
                }}>PARTICULARS</Text>
                <Text style={{
                  width: '20%',
                  borderRightColor: '#fff',
                  borderRightWidth: 1,
                  textAlign: 'center'
                }}>QUANTITY</Text>
                <Text style={{ width: '15%', textAlign: 'center' }}>REMARKS</Text>
              </View>
              {searchinfo && searchinfo.length > 0 && (
                searchinfo.map((product, index) => (
                  <View style={{
                    flexDirection: 'row',
                    borderBottomColor: '#000',
                    borderBottomWidth: 1,
                    alignItems: 'center',
                    height: 24,
                    fontStyle: 'bold',
                    fontSize: 10
                  }}>
                    <Text style={{
                      width: '10%',
                      textAlign: 'left',
                      borderRightColor: '#000',
                      borderRightWidth: 1,
                      paddingLeft: 8,
                    }}>{index + 1}</Text>
                    <Text style={{
                      width: '60%',
                      borderRightColor: '#000',
                      borderRightWidth: 1,
                      textAlign: 'center',
                      paddingRight: 8,
                    }}>{product.productname}</Text>
                    <Text style={{
                      width: '20%',
                      borderRightColor: '#000',
                      borderRightWidth: 1,
                      textAlign: 'center',
                      paddingRight: 8,
                    }}>{product.quantity}</Text>
                    <Text style={{
                      width: '15%',
                      borderRightColor: '#000',
                      borderRightWidth: 1,
                      textAlign: 'center',
                      paddingRight: 8,
                    }}></Text>
                  </View>
                )))}
              <View style={{ display: 'flex', flexDirection: 'column', marginTop: 40 }}>
                <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <Text style={{ fontSize: 12, fontStyle: 'italic', color: 'black' }}>{'Requester Signature:'}</Text>
                  <View style={{ border: 'none', borderBottom: '1px groove	#000000', boxShadow: '-3px', width: '50%', marginBottom: 5, marginLeft: 5 }}></View>
                </View>
                <View style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                  <Text style={{ fontSize: 12, fontStyle: 'italic', color: 'black' }}>{'Approved By'}</Text>
                  <View style={{ border: 'none', borderBottom: '1px groove	#000000', boxShadow: '-3px', width: '50%', marginBottom: 5, marginLeft: 5 }}></View>
                </View>
                <View style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                  <Text style={{ fontSize: 12, fontStyle: 'italic', color: 'black' }}>{'Released By'}</Text>
                  <View style={{ border: 'none', borderBottom: '1px groove	#000000', boxShadow: 'none', width: '50%', marginBottom: 5, marginLeft: 5 }}></View>
                </View>
                <View style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                  <Text style={{ fontSize: 12, fontStyle: 'italic', color: 'black' }}>{'Date,Name and Signature of the Receiver'}</Text>
                  <View style={{ border: 'none', borderBottom: '1px solid	#000000', boxShadow: 'none', width: '45%', marginBottom: 5, marginLeft: 5 }}></View>
                </View>
              </View>
            </View>
          </View>
        </View>
        {/* <View fixed style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          paddingTop: 20,
          zIndex: 0,
          textAlign: 'center',
          marginBottom: 10
        }}>
          <View fixed style={{ borderTop: '1.8px solid black', margin: '0px 20px 0px 20px' }}>
          </View>
        </View> */}

      </Page>
    </Document>
  );

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6" style={{
        width: '100%',
        backgroundImage:
          "url(" +
          require("../../../assets/img/brand/header.jpg").default +
          ")",
      }}>
        <Container fluid >
          <div className="header-body">
            {/* header*/}
            <Row style={{ color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
              <h1 className="mb-0" style={{ color: 'white', alignContent: 'flex-start' }}>PARTS INVENTORY</h1>
              <div style={{ alignContent: 'flex-end', marginRight: '20px' }}>
                {per.includes('parts_edit') ? <Link to="/partsinventory/suppliers"><Button style={{ fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: 'white', borderWidth: 1, borderColor: 'white', backgroundColor: 'transparent' }} >CREATE SUPPLIER</Button>{' '}</Link> :
                  <Button onClick={() => perModal()} style={{ fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: 'white', borderWidth: 1, borderColor: 'white', backgroundColor: 'transparent' }} >CREATE SUPPLIER</Button>}
                {per.includes('parts_edit') ? <Link to="/partsinventory/brands"><Button style={{ fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: 'white', borderWidth: 1, borderColor: 'white', backgroundColor: 'transparent' }} >CREATE BRANDS</Button>{' '}</Link> :
                  <Button onClick={() => perModal()} style={{ fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: 'white', borderWidth: 1, borderColor: 'white', backgroundColor: 'transparent' }} >CREATE BRANDS</Button>}
                {per.includes('parts_edit') ? <Link to="/partsinventory/category"><Button style={{ fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: 'white', borderWidth: 1, borderColor: 'white', backgroundColor: 'transparent' }} >CREATE CATEGORY</Button>{' '}</Link> :
                  <Button onClick={() => perModal()} style={{ fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: 'white', borderWidth: 1, borderColor: 'white', backgroundColor: 'transparent' }} >CREATE CATEGORY</Button>}
                {per.includes('parts_add') ? <Button onClick={() => handleClickOpen()} style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" />ADD NEW PRODUCT</Button> :
                  <Button onClick={() => perModal()} style={{ backgroundColor: 'rgb(219 219 147)', fontSize: '0.625rem', padding: '10px', borderRadius: '30px', color: '#0C6C9A', border: 0 }} ><IcomoonReact iconSet={iconSet} color="#0C6C9A" size={14} icon="add" />ADD NEW PRODUCT</Button>}
                {/* <Link to="/partsinventory/report"><Button style={{ fontSize: '0.625rem', borderRadius: '30px', color: 'white', borderWidth: 1, borderColor: 'white', backgroundColor: 'transparent' }} >REPORT</Button>{' '}</Link> */}
              </div>
            </Row>
          </div>
        </Container>
      </div>
      <Container className="mt--7" style={{ padding: 0 }}>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0" style={{ display: 'flex', color: 'white', fontSize: '1.25rem', paddingLeft: '20px', flexDirection: 'row', justifyContent: 'space-between' }} >
                {filter ? <div style={{ alignContent: 'flex-start' }}><Button onClick={() => Openfilter()} style={{ backgroundColor: 'white', fontSize: '0.625rem', paddingLeft: '30px', paddingLeft: '20px', borderRadius: '10PX', borderColor: '#0C6C9A', color: '#0C6C9A' }}>
                  <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={14} icon="close" />FILTER</Button>{' '}
                </div> :
                  <div style={{ alignContent: 'flex-start' }}><Button onClick={() => Closefilter()} style={{ backgroundColor: 'white', fontSize: '0.625rem', paddingLeft: '30px', paddingLeft: '20px', borderRadius: '10PX', borderColor: '#0C6C9A', color: '#0C6C9A' }}>
                    <IcomoonReact iconSet={iconSet} style={{ flexDirection: 'row', marginRight: 10 }} color="#0C6C9A" size={12} icon="filter" />FILTER</Button>{' '}
                  </div>
                }
                <Col sm={6} style={{ padding: 0 }}>
                  <Form
                    onSubmit={onSubmitFilterkey}
                    render={({ handleSubmit, form }) => (
                      <form
                        onSubmit={async event => {
                          await handleSubmit(event)
                          form.reset()
                        }}>
                        <div className="pl-lg-4">
                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <Field name="search">
                                  {({ input, meta, reset }) => (
                                    <div>
                                      <Input
                                        style={{ backgroundColor: '#E3F7F7' }}
                                        placeholder="Search Products"
                                        value={searchterm}
                                        onKeyUp={(e) => handleKeyPress(e.target.value)}
                                        onChange={(event) => { setSearchTerm(event.target.value) }}
                                        type="text"
                                      />
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            <div style={{ position: 'absolute', right: 10 }}>
                              <Button onClick={() => searchFilter()} style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 0 }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="search" /></Button>
                            </div>
                          </Row>
                        </div>
                      </form>
                    )}
                  />
                </Col >
                <div style={{ alignContent: 'flex-end' }}>
                  <Button onClick={() => PurchaseOpen()} style={{ backgroundColor: '#048eba', borderRadius: 10, color: 'white', borderColor: '#ccc', width: '5.8rem', height: '2.5rem', padding: 5 }} >
                    <label style={{ fontSize: '0.625rem' }}>PURCHAISE REQUEST</label></Button>{' '}
                  {page > 1 || page !== 1 ? <Button onClick={() => onPagination(-1)} style={{ backgroundColor: 'white', fontSize: '0.75rem', height: '2.5rem', padding: '0px', color: 'rgb(66 54 47)', width: '5rem', margin: '0px', borderColor: 'rgb(144 151 153)' }} >
                    <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="prev" />PREV</Button>
                    : <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', height: '2.5rem', padding: '0px', color: '#77665c', width: '5rem', margin: '0px', borderColor: '#ccc' }} >
                      <IcomoonReact style={{ paddingRight: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="prev" />PREV</Button>}
                  {more ? <Button onClick={() => onPagination(1)} style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: 'rgb(66 54 47)', width: '5rem', borderColor: 'rgb(144 151 153)' }} > NEXT
                    <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={11} icon="next" /></Button> :
                    <Button disabled style={{ backgroundColor: 'white', fontSize: '0.7rem', borderColor: '#ccc', padding: '0px', height: '2.5rem', color: '#77665c', width: '5rem', borderColor: '#ccc' }} > NEXT
                      <IcomoonReact style={{ paddingLeft: 5 }} iconSet={iconSet} color="#77665c" size={10} icon="next" /></Button>}
                  {/* <ExportToExcel apiData={exported} fileName="partsinventory" filterProps={filterProps} /> */}
                  <Button onClick={(e) => getEntireData("partsinventory")} style={{ padding: 5, boxShadow: 0, borderWidth: 1, borderColor: '#ccc' }}><IcomoonReact iconSet={iconSet} color="#556F71" size={20} icon="share" /></Button>
                </div>
              </CardHeader>
              {filter ?
                <Col>
                  <Form
                    onSubmit={onSubmitFilter}
                    render={({ handleSubmit }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="pl-lg-4" >
                          <Row>
                            <Col lg="10">
                              <Row>
                                <Col lg="3">
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}>
                                        <IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="status"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }} for="brand">Brand</Label></div>
                                    </div>
                                    <Field name="brand" style={{ marginLeft: 10 }}  >
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)' }} type="select" onChange={(event) => { setSearchBrand(event.target.value) }} name="brand" id="brand" >
                                            <option value="">CHOOSE BRAND</option>
                                            {brands && brands.map(item => (
                                              <option style={{ fontWeight: 600 }} value={item.id}>{item.brand}</option>
                                            ))}
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                                <Col lg="3" >
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="categories"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }} for="brand">Categories</Label></div>
                                    </div>
                                    <Field name="category" >
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)' }} type="select" onChange={(event) => { setSearchCategory(event.target.value) }} name="category" id="category" >
                                            <option value="">CHOOSE CATEGORY</option>
                                            {category && category.map(item => (
                                              <option style={{ fontWeight: 600 }} value={item._id}>{item.category}</option>
                                            ))}
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                                <Col lg="3"  >
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="share"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }} for="brand">Supplier</Label></div>
                                    </div>
                                    <Field name="supplier" >
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)' }} type="select" onChange={(event) => { setSearchSupplier(event.target.value) }} name="supplier" id="supplier">
                                            <option value="">CHOOSE SUPPLIER</option>
                                            {suppliers && suppliers.map(item => (
                                              <option style={{ fontWeight: 600 }} value={item.id}>{item.supplier}</option>
                                            ))}
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                                <Col lg="3"  >
                                  <FormGroup >
                                    <div style={{ display: 'flex' }}>
                                      <div style={{ flexDirection: 'row' }}><IcomoonReact iconSet={iconSet} color="rgb(117 204 238)" size={16} icon="status"> </IcomoonReact></div>
                                      <div style={{ flexDirection: 'row', marginLeft: 10 }}><Label style={{ fontSize: ' 0.8rem' }}>Stockstatus</Label></div>
                                    </div>
                                    <Field name="stock">
                                      {({ input, meta, value }) => (
                                        <div>
                                          <Input style={{ borderColor: 'rgb(231 235 238)' }} type="select" onChange={(event) => { setSearchStock(event.target.value) }} name="stock" >
                                            <option style={{ fontWeight: 600 }} value=''>CHOOSE STOCK STATUS</option>
                                            <option style={{ fontWeight: 600 }} value="true">INSTOCK</option>
                                            <option style={{ fontWeight: 600 }} value="false">OUTSTOCK</option>
                                          </Input>
                                        </div>
                                      )}
                                    </Field>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Col>
                            <Col lg="1" style={{ marginLeft: 10, marginTop: 30, paddingLeft: 20 }}>
                              <Button type="submit" onClick={() => Filter_dropdown()} style={{ backgroundColor: 'rgb(72 184 227)', color: 'white', border: 0, width: '7rem', borderRadius: 5 }}>Apply</Button>
                            </Col>
                          </Row>
                        </div>
                      </form>
                    )}
                  />
                </Col > : null}
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">
                      <FormGroup check style={{ paddingBottom: '20px' }}>
                        <Input type="checkbox" />{' '}
                      </FormGroup>
                    </th>
                    <th scope="col"><span className="tablehead">PRODUCT NAME</span></th>
                    <th scope="col"><span className="tablehead">CATEGORY</span></th>
                    <th scope="col"><span className="tablehead">BRAND</span></th>
                    <th scope="col"><span className="tablehead">SKU</span></th>
                    <th scope="col"><span className="tablehead">QUANTITY</span></th>
                    <th scope="col"><span className="tablehead">PURCHASE PRICE</span></th>
                    <th scope="col"><span className="tablehead">CURRENT PRICE</span></th>
                    <th scope="col"><span className="tablehead">STOCK</span></th>
                    <th scope="col"><span className="tablehead">SUPPLIER</span></th>
                    <th scope="col"><span className="tablehead">ACTION</span></th>
                  </tr>
                </thead>
                <tbody>
                  {!products || products.length < 1 ? (
                    <tr>
                      <td style={{ color: '#12ACF6', textAlign: 'center', padding: 20, margin: 20 }} colSpan={11}>No Results found
                        <IcomoonReact style={{ marginLeft: 10 }} iconSet={iconSet} color="#12ACF6" size={22} icon="search" />
                      </td>
                    </tr>
                  ) : (
                    <>

                      {products.map((product, index) => (
                        <tr style={{ paddingRight: 0 }}>
                          <th>
                            <FormGroup check style={{ paddingBottom: '20px' }}>
                              <Input type="checkbox" />{' '}
                            </FormGroup>
                          </th>
                          <td style={{ color: '#12ACF6', textTransform: 'capitalize', paddingRight: 0, fontSize: '0.75rem', fontWeight: 600, whiteSpace: 'normal' }}>{product.name}</td>
                          <td style={{ width: 10, fontWeight: 'bold', color: '#767576', paddingRight: 0, fontSize: '0.75rem' }}>{product?.category?.category || '-'}</td>
                          <td style={{ width: 10, textTransform: 'uppercase', paddingRight: 0, fontSize: '0.7rem' }}>{product?.brand?.brand || '-'}</td>
                          <td style={{ paddingRight: 0 }}>{product?.sku || '-'}</td>
                          <td style={{ textAlign: 'center' }}>{product?.quantity}</td>
                          <td style={{ paddingRight: 0 }}>{product?.purchase_price || '-'}</td>
                          <td style={{ paddingRight: 0 }}>{product?.price || '-'}</td>
                          <td style={{ color: product?.quantity <= 0 ? 'red' : 'green', paddingRight: 0 }}>{product?.quantity <= 0 ? 'Outstock' : 'Instock'}</td>
                          {/* <td style={{ color: 'green' }}>{product?.status === 1 ? 'Instock' : 'Outstock'}</td> */}
                          <td style={{ color: '#d1c2ce', textTransform: 'capitalize' }}>{product?.supplier?.supplier || '-'}</td>
                          <td style={{ flexDirection: 'row', display: 'flex', paddingLeft: 0, marginLeft: 0, paddingRight: 0 }}>
                            <Button onClick={() => viewopen(index)} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="#ccc" size={18} icon="view" /></Button>
                            {per.includes('parts_edit') ? <Link to={{ pathname: "/partsinventory/edit/", state: product.id }}>
                              <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center', marginLeft: 10 }} ><IcomoonReact iconSet={iconSet} color="#ccc" size={16} icon="edit" /></Button>
                            </Link> :
                              <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center', marginLeft: 10 }} ><IcomoonReact iconSet={iconSet} color="#ccc" size={19} icon="edit" /></Button>}
                            {per.includes('parts_delete') ? <Button style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center', marginLeft: 10 }} onClick={() => setConfirmOpen({ visible: true, id: product.id, index: index })}><IcomoonReact iconSet={iconSet} color="#ccc" size={19} icon="delete" /></Button> :
                              <Button onClick={() => perModal()} style={{ boxShadow: 'none', backgroundColor: '#fff', borderColor: '#fff', padding: 0, textAlign: 'center', marginLeft: 10 }} ><IcomoonReact iconSet={iconSet} color="#ccc" size={19} icon="delete" /></Button>}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
              <Modal isOpen={confirmOpen.visible} size="sm">
                <ModalBody style={{ color: 'red' }}>DO YOU WANT DELETE THIS ?</ModalBody>
                <ModalFooter >
                  <Button onClick={Closeconfirm} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    NO
                  </Button>
                  <Button onClick={() => removeData(confirmOpen.id, confirmOpen.index)} style={{ color: 'white', backgroundColor: 'rgb(5 160 187)', border: 0 }} type="button">
                    YES
                  </Button>
                </ModalFooter>
              </Modal>
            </Card>
          </div>
        </Row>
      </Container>
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={open}
          size="lg" style={{ maxWidth: '600px', width: '100%' }}
        >
          <div onClick={() => setOpen(false)} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-12px', top: '-10px', borderRadius: '50%', cursor: 'pointer' }}>
            <IcomoonReact iconSet={iconSet} onClick={() => setOpen(false)} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#044057', paddingBottom: 30, color: 'white', paddingTop: 20, fontWeight: 'bold' }}> ADD NEW PRODUCT</div>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setOpen(false)}
          >
            <IcomoonReact iconSet={iconSet} color="white" size={14} icon="close" />
          </button>
          <div>
            <Form
              onSubmit={onSubmit}
              render={({ handleSubmit, values, submitting, validating, valid }) => (
                <form
                  onSubmit={handleSubmit}
                  style={{ padding: '20px' }}>
                  <div className="pl-lg-4">
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <Label for="name" style={{ fontSize: ' 0.85rem', color: '#756a5c' }}>Product Name</Label>
                          <Field validate={required} name="name" >
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  type="text"
                                  {...input}
                                  placeholder="Product name"
                                  style={{ color: 'black', borderRadius: 10 }}
                                  invalid={meta.error && meta.touched}
                                />
                                {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup >
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }} for="category">Choose Category</Label>
                          <Field name="category" >
                            {({ input, meta, value }) => (
                              <div>
                                {/* <IcomoonReact iconSet={iconSet} color="rgb(0 139 183)" size={14} icon="drop-down" style={{ position: 'absolute', right: 18, top: 44 }}> </IcomoonReact> */}
                                <Input required type="select" onChange={(e) => setSelectedOption_category(e.target.value)} name="category" id="category" style={{ color: 'black', borderRadius: 10 }}>
                                  <option value="">--Select Category--</option>
                                  {category && category.map(item => (
                                    <option value={item._id}>{item.category}</option>
                                  ))}

                                </Input>
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup >
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }} for="brand">Brand</Label>
                          <Field name="brand" >
                            {({ input, meta, value }) => (
                              <div>
                                <Input type="select" onChange={(e) => setSelectedOption_brand(e.target.value)} name="brand" id="brand" style={{ color: 'black', borderRadius: 10 }}>
                                  <option value="">--choose Brand--</option>
                                  {brands && brands.map(item => (
                                    <option value={item.id}>{item.brand}</option>
                                  ))}
                                </Input>
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }} for="sku">SKU</Label>
                          <Field validate={required} name="sku" >
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  type="text"
                                  name="sku"
                                  style={{ color: 'black', borderRadius: 10 }}
                                  placeholder="145"
                                  invalid={meta.error && meta.touched}
                                />
                                {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup >
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }} for="supplier">Supplier</Label>
                          <Field name="supplier" >
                            {({ input, meta, value }) => (
                              <div>
                                <Input onChange={(e) => setSelectedOption_supplier(e.target.value)} type="select" name="supplier" id="supplier" style={{ color: 'black', borderRadius: 10 }}>
                                  <option value="">--choose Suppliers--</option>
                                  {suppliers && suppliers.map(item => (
                                    <option value={item.id}>{item.supplier}</option>
                                  ))}
                                </Input>
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }} for="phone">Quantity</Label>
                          <Field name="quantity" validate={composeValidators(required, mustBeNumber)}>
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  type="number"
                                  min="0"
                                  style={{ color: 'black', borderRadius: 10 }}
                                  placeholder="50"
                                  invalid={meta.error && meta.touched}
                                />
                                {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="4">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }}>Purchaise price</Label>
                          <Field name="purchase_price" >
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  type="number"
                                  style={{ color: 'black', borderRadius: 10 }}
                                  placeholder="QAR 145.00"
                                />
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }}>Current price</Label>
                          <Field name="price" >
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  type="number"
                                  style={{ color: 'black', borderRadius: 10 }}
                                  placeholder="QAR 145.00"
                                />
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                      <Col lg="4">
                        <FormGroup >
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }} >Unit</Label>
                          <Field name="unit" >
                            {({ input, meta, value }) => (
                              <div>
                                <Input required onChange={(e) => setSelectedOption_unit(e.target.value)} type="select" name="supplier" id="supplier" style={{ color: 'black', borderRadius: 10 }}>
                                  <option value="">--select--</option>
                                  <option value="number">Number</option>
                                  <option value="box">Boxes</option>
                                  <option value="packet">Packets</option>
                                  <option value="kg">Kilogram</option>
                                  <option value="liter">Liter</option>
                                  <option value="cm">Centimeter</option>
                                </Input>
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12">
                        <FormGroup>
                          <Label style={{ fontSize: ' 0.85rem', color: '#756a5c' }} for="description">Description</Label>
                          <Field name="description" >
                            {({ input, meta }) => (
                              <div>
                                <Input
                                  {...input}
                                  type="textarea"
                                  style={{ color: 'black', padding: 20, borderRadius: 10, overflow: 'hidden' }}
                                  placeholder="Description"
                                />
                                {meta.error && meta.touched && <span style={{ color: 'red', fontSize: '0.7rem' }}>{meta.error}</span>}
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <Col md="6">
                    <Button disabled={loading} color={'white'} type="submit" style={{ backgroundColor: 'rgb(0 139 183)', marginLeft: '10px', color: 'white', width: '100%', borderRadius: '10px', border: 0, padding: 15, fontWeight: 'bold' }} >
                      {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                      ADD PRODUCT</Button>{' '}
                  </Col>
                </form>
              )}
            />
          </div>
        </Modal>
      </div>

      {/* purchase request */}
      <div>
        <Modal
          size="lg" style={{ maxWidth: '600px', height: '100px' }}
          className="modal-dialog-centered"
          isOpen={purchaseOpen}
        >
          <div onClick={purchaseClose} style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-10px', borderRadius: '50%', top: '-10px', cursor: 'pointer' }}>
            <IcomoonReact iconSet={iconSet} onClick={purchaseClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div style={{ display: 'block', textAlign: 'center' }} >
            <h2 style={{ alignItems: "center", marginTop: '20px', marginLeft: 20 }} className="modal-title" id="exampleModalLabel">
              <label style={{ fontSize: '1rem', fontWeight: 'bold' }}>PURCHASE REQUEST</label>
            </h2>
          </div>
          <div>
            <Form
              onSubmit={onSubmit_purchase}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div>
                    <Row style={{ padding: 20 }}>
                      <Col md="12">
                        <FormGroup>
                          <Field name="search">
                            {({ input, meta }) => (
                              <div>
                                <ReactSearchAutocomplete
                                  styling={{
                                    borderRadius: '8px',
                                    clearIconMargin: '0 0 0 10px',
                                    searchIconMargin: '0 10px 0 0',
                                    placeholderColor: "#ccc",
                                    zIndex: 999,

                                  }}
                                  onSelect={selectproducts}
                                  required
                                  placeholder='Search products'
                                  items={productresult}
                                  fuseOptions={{ keys: ["name", "sku"] }}
                                  resultStringKeyName="name"
                                  autoFocus
                                />
                              </div>
                            )}
                          </Field>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  {error ? <span style={{ color: 'red', fontSize: '0.8rem', marginLeft: 150, paddingBottom: 20, textAlign: 'center', display: 'flex' }}>{error}</span> : null}
                </form>
              )}
            />
          </div>
          {selectedproducts && selectedproducts.length > 0 ?
            <Scrollbars
              renderThumbVertical={props => < div {...props} className="thumb-vertical" />}
              renderTrackVertical={props => < div {...props} className="track-vertical" />}
              renderThumbHorizontal={props => < div {...props} />}
              style={{ height: 200, textAlign: 'center' }}>
              {/* style={{ width: '80%', marginLeft: 40, height: '200px', overflow: 'scroll', display: 'block', textAlign: 'center' }} */}
              <Table className="align-items-center table-flush" >

                <thead style={{ backgroundColor: 'white' }}>
                  <tr style={{ color: '#cacddc' }}>
                    <th scope="col">PRODUCTS</th>
                    <th scope="col">QUANTITY</th>
                    <th scope="col">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedproducts && selectedproducts.length > 0 && (
                    selectedproducts.map((product, index) => (
                      <>
                        <tr>
                          <td style={{ color: '#8aa5ae', verticalAlign: 'middle' }}>{product.name}</td>
                          <td>
                            <Input
                              style={{ backgroundColor: 'rgb(241 242 243)', display: 'inherit', width: 80, borderRadius: 10, fontWeight: 'bold', textAlign: 'center', padding: 0 }}
                              type="text"
                              // value={validatenumber}
                              onChange={(e) => SearchInfoQuantity(e.target.value, product.id)}
                            />
                          </td>

                          <td >
                            <Button onClick={() => removeProducts(product?.id)} style={{ boxShadow: 'none', backgroundColor: '#fd5151', borderColor: '#fff', padding: 4, textAlign: 'center' }} ><IcomoonReact iconSet={iconSet} color="white" size={16} icon="delete" /> </Button>
                          </td>
                        </tr>
                      </>
                    )))}
                </tbody>
              </Table>
            </Scrollbars>
            : null}

          {purchasedata?.id ? <PDFDownloadLink
            style={{ backgroundColor: '#b9af72', display: 'flex', justifyContent: 'center', width: 120, borderRadius: 20, color: 'white', alignSelf: 'center', marginBottom: 10, padding: 5 }}
            document={<Doc />}
            fileName="PurchaseOrder.pdf">
            {/* {({ blob, url, loading, error }) => (console.log(blob, url, loading, error))} */}
            {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
          </PDFDownloadLink> :
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                style={{ backgroundColor: 'rgb(4 142 186)', color: 'white', border: 0, marginBottom: 20, borderRadius: '40px', padding: '10px 40px 10px 40px', fontWeight: 'bold', fontSize: '0.9rem' }}
                onClick={() => { Purchasesave(); }}>GENERATE PDF  <AiOutlineArrowRight style={{ fontSize: 20 }} /> </Button>
            </div>}
        </Modal>
      </div>
      {/* <PDFViewer style={{ width: '80vw', height: '160vh' }}>
        <Doc />
      </PDFViewer> */}
      <div style={{ width: '600px' }}>
        <Modal
          className="modal-dialog-centered"
          isOpen={view_open}
          size="lg" style={{ maxWidth: '600px', width: '100%' }}
        >
          <div style={{ backgroundColor: 'rgb(193 193 125)', width: '30px', height: '30px', position: 'absolute', right: '-12px', top: '-10px', borderRadius: '50%' }}>
            <IcomoonReact iconSet={iconSet} onClick={viewClose} style={{ position: 'absolute', right: 10, top: 10 }} color="white" size={12} icon="close" />
          </div>
          <div style={{ textAlign: 'center', backgroundColor: '#008bb7', padding: 20 }} >
            <h2 style={{ marginTop: '20px', marginLeft: 20, textAlign: 'center', color: 'white' }} className="modal-title" >
              VIEW PARTS INVENTORY
            </h2>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={viewClose}
            >
            </button>
          </div>
          <div style={{ padding: 30 }}>
            <div className="pl-lg-4">
              <Row>
                <Col md="6">
                  <Label style={{ fontSize: ' 0.8125rem' }} >product</Label>
                  <Input
                    value={products[pos]?.name ? products[pos]?.name : ''}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
                <Col lg="6">
                  <Label style={{ fontSize: ' 0.8125rem' }} for="category">Choose Category</Label>
                  <Input
                    value={products[pos]?.category?.category}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <Label style={{ fontSize: ' 0.8125rem' }} for="category">Choose Brand</Label>
                  <Input
                    value={products[pos]?.brand?.brand}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
                <Col md="6">
                  <Label style={{ fontSize: ' 0.8125rem' }} >SKU</Label>
                  <Input
                    value={products[pos]?.sku ? products[pos]?.sku : ''}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <Label style={{ fontSize: ' 0.8125rem' }} >supplier</Label>
                  <Input
                    value={products[pos]?.supplier?.supplier}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
                <Col lg="6">
                  <Label style={{ fontSize: ' 0.8125rem' }} for="phone">Quantity</Label>
                  <Input
                    value={products[pos]?.quantity ? products[pos]?.quantity : ''}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg="6">
                  <Label style={{ fontSize: ' 0.8125rem' }}>Purchaise price</Label>
                  <Input
                    value={products[pos]?.quantity ? products[pos]?.purchase_price : ''}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
                <Col lg="6">
                  <Label style={{ fontSize: ' 0.8125rem' }}>Current price</Label>

                  <Input
                    value={products[pos]?.quantity ? products[pos]?.price : ''}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />

                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <Label style={{ fontSize: ' 0.8125rem' }} for="description">Description</Label>
                  <Input
                    value={products[pos]?.description ? products[pos]?.description : ''}
                    disabled
                    type="text"
                    style={{ color: 'black', backgroundColor: 'transparent' }}
                  />
                </Col>
              </Row>
            </div>
            <div style={{ marginTop: 20, textAlign: 'center' }}>
              <Button disabled={loading} onClick={viewClose} color={'white'} type="submit" style={{ backgroundColor: '#008bb7', color: 'white', width: '50%', borderRadius: '10px', flex: 1, border: 0 }} >
                {loading && (<Spinner as="span" size="sm" role="status" aria-hidden="true" style={{ marginRight: 20 }} />)}
                DONE</Button>{' '}
            </div>

          </div>
        </Modal>
      </div>
      {/* created sucess modal */}
      <Modal isOpen={sucess} size="sm">
        <ModalBody style={{ color: 'green' }}>Created successfully!</ModalBody>
      </Modal>
      {/* created sucess modal */}
      <Modal isOpen={modalOpen} size="sm">
        <ModalBody style={{ backgroundColor: 'rgb(219 219 147)', color: 'white' }}>Your session has expired. Please sign in again.</ModalBody>
        <ModalFooter>
          <Button onClick={() => onLogout()} style={{ backgroundColor: '#09577C', color: 'white' }} type="button">
            LOGOUT
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={peropen} size="sm">
        <ModalBody style={{ color: 'red' }}>You have no acess to change it..!</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20 }}>
          <Button onClick={() => setPeropen(false)} style={{ backgroundColor: 'red', color: 'white', border: 0 }}>Ok</Button>
        </div>
      </Modal>
      <Modal isOpen={alreadyexist} size="sm">
        <ModalBody style={{ color: 'red' }}>Product Already Exist..</ModalBody>
        <div style={{ display: 'flex', justifyContent: 'center' }}><Button style={{ width: '25%', marginBottom: 20, backgroundColor: '#F9856D', border: 0 }} onClick={() => setAlreadyexist(false)}>OK</Button></div>
      </Modal>
    </>
  );
};

export default Partsinventory;

